import { Link, useHistory } from "react-router-dom";
import LogoSVG from "../../assets/svg/Logo";
import PatientSearch from "./PatientSearch";
import ContextSelector from "./ContextSelector";
import NotificationIcon from "../../assets/svg/NotificationIcon";
import HelpIcon from "../../assets/svg/HelpIcon";
import RequiredFieldTooltip from "./RequiredFieldTooltip";
import ProfileDropdown from "./ProfileDropdown";
import { useOktaAuth } from "@okta/okta-react";
import { Fragment, useContext, useEffect } from "react";
import { ApplicationState } from "../../services/context/ApplicationStateContext";
import useProfile from "../../services/utils/custom hooks/useProfile";
import { useAdminContext } from "../../services/context/TourPopupContext";
import useFeatureFlags from "../../services/utils/custom hooks/Feature Flagging/useFeatureFlags";
import dataConstants from "../../constants/dataConstants";
import TabletModePatientSearch from "./TabletModePatientSearch";
import Selectors from "./Selectors";
import HamburgerIcon from "../../assets/svg/SideNav/HamburgerIcon";
function NotificationBadge({
  unReadCount,
}: {
  unReadCount: number;
}): JSX.Element | null {
  if (unReadCount === 0) return null;
  return (
    <div
      className={`bg-[#FE4F4F] ${
        unReadCount > 99 ? "h-[18px] w-[18px]" : "h-[15px] w-[15px]"
      } rounded-full absolute   truncate  top-0 right-0`}
    >
      <p
        className={`text-white ${
          unReadCount > 99 ? "text-[8px] mt-1" : "text-xs"
        } text-center`}
      >
        {unReadCount > 100 ? (
          <span>
            100<sup>+</sup>
          </span>
        ) : (
          unReadCount
        )}
      </p>
    </div>
  );
}

function NotificationBellIcon() {
  const history = useHistory();
  const {
    state: { notificationCount },
  } = useContext(ApplicationState);

  const { isTourActive } = useAdminContext();

  useEffect(() => {}, [notificationCount]);
  return (
    <div className="relative">
      <NotificationIcon
        onClick={() =>
          isTourActive ? undefined : history.push("/access/notifications")
        }
        className={`${
          isTourActive ? "cursor-not-allowed" : "cursor-pointer"
        } mt-2`}
      />
      <NotificationBadge unReadCount={notificationCount} />
    </div>
  );
}

function HeaderRightSection({
  profileData,
  profileError,
  isLoadingProfile,
}: Readonly<{
  profileData: any;
  profileError: any;
  isLoadingProfile: any;
}>) {
  const history = useHistory();

  const { isTourActive } = useAdminContext();
  const { isSectionActive } = useFeatureFlags();
  const roles = profileData?.user?.roles ?? [];
  const isCOA = roles.includes("Collaborative Order Agreement");

  return (
    <div className="flex justify-end items-center w-full">
      <Selectors className="hidden md:flex" profile={profileData} />
      <div id="step4" className="flex items-center">
        <div
          className={`flex ${
            isCOA
              ? "lg:space-x-[22px] space-x-2"
              : "xl:space-x-[22px] space-x-2"
          }`}
        >
          <TabletModePatientSearch />
          {isSectionActive(
            dataConstants.FeatureFlagSectionKeys.NOTIFICATIONS
          ) && (
            <RequiredFieldTooltip
              required
              showLeft={
                !isSectionActive(
                  dataConstants.FeatureFlagSectionKeys.USER_PROFILE
                )
              }
              tooltipText="Notifications"
            >
              <NotificationBellIcon />
            </RequiredFieldTooltip>
          )}
          {isSectionActive(dataConstants.FeatureFlagSectionKeys.HELP) && (
            <RequiredFieldTooltip
              required
              tooltipText="Help"
              showLeft={
                !isSectionActive(
                  dataConstants.FeatureFlagSectionKeys.USER_PROFILE
                )
              }
            >
              <HelpIcon
                onClick={() =>
                  isTourActive ? undefined : history.push("/access/help")
                }
                className={`${
                  isTourActive ? "cursor-not-allowed" : "cursor-pointer"
                } mt-2`}
              />
            </RequiredFieldTooltip>
          )}
        </div>
        {isSectionActive(dataConstants.FeatureFlagSectionKeys.USER_PROFILE) && (
          <ProfileDropdown
            data={profileData}
            isError={profileError}
            isLoading={isLoadingProfile}
          />
        )}
      </div>
    </div>
  );
}

function Header({
  toggleMobileMenu,
  closeMobileMenu,
}: Readonly<{
  toggleMobileMenu?: () => void;
  closeMobileMenu?: () => void;
}>): JSX.Element {
  const { authState } = useOktaAuth();
  const {
    data: profileData,
    isLoading: isLoadingProfile,
    isError: profileError,
  } = useProfile();
  return (
    <header className=" p-3 md:px-6 lg:px-3 border-b top-0 w-full flex justify-between">
      <div className="flex justify-center items-center lg:justify-items-stretch lg:items-stretch ">
        {authState?.isAuthenticated && (
          <button
            type="button"
            onClick={toggleMobileMenu}
            className="xs:block  md:hidden hidden py-1.5 pr-1.5 mr-1 -mt-2"
          >
            <HamburgerIcon />
          </button>
        )}
        <Link to={authState?.isAuthenticated ? "/access/dashboard" : "/"}>
          <LogoSVG />
        </Link>
        {authState?.isAuthenticated && (
          <div className="w-full hidden lg:flex">
            <PatientSearch mode="dropdown" closeInput={() => {}} />
          </div>
        )}
      </div>
      {authState?.isAuthenticated && (
        <HeaderRightSection
          profileData={profileData}
          profileError={profileError}
          isLoadingProfile={isLoadingProfile}
        />
      )}
    </header>
  );
}

export default Header;
